<div class="container">
    <mat-card class="example-card">
      <mat-card-header>
        <!-- <div mat-card-avatar class="example-header-image"></div> -->
        <mat-card-title>Ekasi App</mat-card-title>
        <mat-card-subtitle>Account Payment</mat-card-subtitle>
      </mat-card-header>
      <img mat-card-image src="assets/failed-background.jpg" alt="Payment background image">
      <mat-card-content>
        <h3>Your transaction was cancelled, return to your Ekasi app to continue.</h3>
      </mat-card-content>
      <mat-card-actions>
        <button mat-stroked-button color="primary" class="full-width">Open Ekasi App</button>
        <!-- <button mat-button>SHARE</button> -->
      </mat-card-actions>
    </mat-card>
  </div>
